import OverviewTab from "../Pages/ServicesPage/ServicesTabs/SeafarerServicesTab/OverviewTab";
import SyllabusCommitteTab from "../Pages/ServicesPage/ServicesTabs/SeafarerServicesTab/SyllabusCommitteTab";
import SmallVesselsSafetyOverviewTab from "../Pages/ServicesPage/ServicesTabs/SmallVesselsSafetyTab/SmallVesselsSafetyOverviewTab";
import SmallVesselsSafetyLicensingTab from "../Pages/ServicesPage/ServicesTabs/SmallVesselsSafetyTab/SmallVesselsSafetyLicensingTab";
import SmallVesselsSafetySurveysTab from "../Pages/ServicesPage/ServicesTabs/SmallVesselsSafetyTab/SmallVesselsSafetySurveysTab";
import SmallVesselsSafetyAccreditationTab from "../Pages/ServicesPage/ServicesTabs/SmallVesselsSafetyTab/SmallVesselsSafetyAccreditationTab";
import SeaWatchReponseOverviewTab from "../Pages/ServicesPage/ServicesTabs/SeaWatchReponseTab/SeaWatchReponseOverviewTab";
import SeaWatchReponseMrccTab from "../Pages/ServicesPage/ServicesTabs/SeaWatchReponseTab/SeaWatchReponseMrccTab";
import SeaWatchReponseInterventionTab from "../Pages/ServicesPage/ServicesTabs/SeaWatchReponseTab/SeaWatchReponseInterventionTab";
import SeaWatchReponseAidsToNavigationTab from "../Pages/ServicesPage/ServicesTabs/SeaWatchReponseTab/SeaWatchReponseAidsToNavigationTab";
import SeaWatchReponseErirbRegistrationTab from "../Pages/ServicesPage/ServicesTabs/SeaWatchReponseTab/SeaWatchReponseErirbRegistrationTab";
import ShippingSafetyOverviewTab from "../Pages/ServicesPage/ServicesTabs/ShippingSafety/ShippingSafetyOverviewTab";
import ShippingSafetyShippingTab from "../Pages/ServicesPage/ServicesTabs/ShippingSafety/ShippingSafetyShippingTab";
import ShippingSafetyFishingTab from "../Pages/ServicesPage/ServicesTabs/ShippingSafety/ShippingSafetyFishingTab";
import ShippingSafetyCleanseasTab from "../Pages/ServicesPage/ServicesTabs/ShippingSafety/ShippingSafetyCleanseasTab";
import ShippingSafetyPortStateControlTab from "../Pages/ServicesPage/ServicesTabs/ShippingSafety/ShippingSafetyPortStateControlTab";
import NavalArchitectureOverviewTab from "../Pages/ServicesPage/ServicesTabs/NavalArchitectureTab/NavalArchitectureOverviewTab";
import NavalArchitectureVesselConstructionTab from "../Pages/ServicesPage/ServicesTabs/NavalArchitectureTab/NavalArchitectureVesselConstructionTab";
import ShipRegistryOverviewTab from "../Pages/ServicesPage/ServicesTabs/ShipRegistryTab/ShipRegistryOverviewTab";
import ShipRegistryRegistrationTab from "../Pages/ServicesPage/ServicesTabs/ShipRegistryTab/ShipRegistryRegistrationTab";
import ShipRegistryMortgagesOwnershipTab from "../Pages/ServicesPage/ServicesTabs/ShipRegistryTab/ShipRegistryMortgagesOwnershipTab";
import ShipRegistryOffencesTab from "../Pages/ServicesPage/ServicesTabs/ShipRegistryTab/ShipRegistryOffencesTab";
import FishingOverviewTab from "../Pages/ServicesPage/ServicesTabs/FishingTab/FishingOverviewTab";
import FishingNationalFishingForumTab from "../Pages/ServicesPage/ServicesTabs/FishingTab/FishingNationalFishingForumTab";
import FormsAllFormsTab from "../Pages/ServicesPage/ServicesTabs/FormsTab/FormsAllFormsTab";
import FormsShippingSmallVesselSafetyFormsTab from "../Pages/ServicesPage/ServicesTabs/FormsTab/FormsShippingSmallVesselSafetyFormsTab";
import FormsSeafarerFormsTab from "../Pages/ServicesPage/ServicesTabs/FormsTab/FormsSeafarerFormsTab";
import FormsShipRegistryFormsTab from "../Pages/ServicesPage/ServicesTabs/FormsTab/FormsShipRegistryFormsTab";
import FormsNavalArchitectureFormTab from "../Pages/ServicesPage/ServicesTabs/FormsTab/FormsNavalArchitectureFormTab";
import AuditAccreditationOverviewTab from "../Pages/ServicesPage/ServicesTabs/AuditAccreditationTab/AuditAccreditationOverviewTab";
import AuditAccreditationAuthorizedTab from "../Pages/ServicesPage/ServicesTabs/AuditAccreditationTab/AuditAccreditationAuthorizedTab";
import MedicalTab from "../Pages/ServicesPage/ServicesTabs/SeafarerServicesTab/MedicalTab";
import VerificationsTab from "../Pages/ServicesPage/ServicesTabs/SeafarerServicesTab/VerificationsTab";

// import VerificationsAdmin from "../Pages/ServicesPage/ServicesTabs/SeafarerServicesTab/VerificationsAdmin";

import MoshTab from "../Pages/ServicesPage/ServicesTabs/SeafarerServicesTab/MoshTab";
import AccreditationTab from "../Pages/ServicesPage/ServicesTabs/SeafarerServicesTab/AccreditationTab";
// import SeafarerWelfareTab from "../Pages/ServicesPage/ServicesTabs/SeafarerServicesTab/SeafarerWelfareTab";
import AssessmentCertificationTab from "../Pages/ServicesPage/ServicesTabs/SeafarerServicesTab/AssessmentCertificationTab";
import AwarenessCampaigns from "../Pages/ServicesPage/ServicesTabs/Mosh/AwarenessCampaigns";
import ComplianceRegime from "../Pages/ServicesPage/ServicesTabs/Mosh/ComplianceRegime";
import MoshOverviewTab from "../Pages/ServicesPage/ServicesTabs/Mosh/MoshOverviewTab";
import ShipRepairMaintenance from "../Pages/ServicesPage/ServicesTabs/Mosh/ShipRepairMaintenance";
import VGM from "../Pages/ServicesPage/ServicesTabs/Mosh/VGM";
import StevedoringTab from "../Pages/ServicesPage/ServicesTabs/Mosh/StevedoringTab";
import Vessels from "../Pages/ServicesPage/ServicesTabs/Mosh/Vessel";
import OffshoreBunkerOverview from "../Pages/ServicesPage/ServicesTabs/OPLOperationsTab/OffshoreBunkerOverview";
import OPLOperations from "../Pages/ServicesPage/ServicesTabs/OPLOperationsTab/OPLOperations";
import OffshoreBunkering from "../Pages/ServicesPage/ServicesTabs/OPLOperationsTab/OffshoreBunkering";
import IncidentalPersons from "../Pages/ServicesPage/ServicesTabs/Mosh/IncidentalPersons";
import Resources from "../Pages/ServicesPage/ServicesTabs/Mosh/Resources";
import IncidentReportingFormTab from "../Pages/ServicesPage/ServicesTabs/IncidentReportingFormTab/IncidentReportingFormTab";



const accordionSections = [
  {
    title: "SEAFARER SERVICES",
    items: [
      { id: "seafarer-overview", label: "OVERVIEW", component: <OverviewTab /> },
      { id: "seafarer-syllabus", label: "SYLLABUS COMMITTEE", component: <SyllabusCommitteTab /> },
      { id: "seafarer-accreditation", label: "ACCREDITATION", component: <AccreditationTab /> },
      // { id: "seafarer-mosh", label: "MOSH", component: <MoshTab /> },
      // { id: "seafarer-welfare", label: "SEAFARER WELFARE", component: <SeafarerWelfareTab /> },
      { id: "seafarer-assessment", label: "ASSESSMENT AND CERTIFICATION", component: <AssessmentCertificationTab /> },
      { id: "seafarer-medical", label: "MEDICAL PRACTITIONERS", component: <MedicalTab /> },
      { id: "seafarer-verifications", label: "Verifications", component: <VerificationsTab /> },
      // { id: "verifications-Admin", label: "Verifications Admin", component: <VerificationsAdmin /> },
    ],

  },

  {
    title: "OHS",
    items: [
      { id: "Mosh-OverviewTab", label: "About", component: <MoshOverviewTab /> },
      { id: "Stevedoring-Tab", label: "Stevedores", component: <StevedoringTab /> },
      { id: "ShipRepair-Maintenance", label: "Ship repair and maintenance", component: <ShipRepairMaintenance /> },
      { id: "Vessels", label: "Vessels", component: <Vessels /> },
      { id: "Resources", label: "Resourcess", component: <Resources /> },
      { id: "VGM", label: "VGM", component: <VGM /> },
    ],
  },
  {
    title: "SMALL VESSEL SAFETY",
    items: [
      { id: "vessels-overview", label: "OVERVIEW", component: <SmallVesselsSafetyOverviewTab /> },
      { id: "vessels-licensing", label: "LICENSING", component: <SmallVesselsSafetyLicensingTab /> },
      { id: "vessels-surveys", label: "SURVEYS", component: <SmallVesselsSafetySurveysTab /> },
      { id: "vessels-accreditation", label: "ACCREDITATION", component: <SmallVesselsSafetyAccreditationTab /> },
    ],
  },
  {
    title: "SEA WATCH & RESPONSE",
    items: [
      { id: "watch-overview", label: "OVERVIEW", component: <SeaWatchReponseOverviewTab /> },
      { id: "watch-mrcc", label: "MRCC", component: <SeaWatchReponseMrccTab /> },
      { id: "watch-intervention", label: "INTERVENTION", component: <SeaWatchReponseInterventionTab /> },
      { id: "watch-navigation", label: "AIDS TO NAVIGATION", component: <SeaWatchReponseAidsToNavigationTab /> },
      { id: "watch-epirb", label: "EPIRB registration", component: <SeaWatchReponseErirbRegistrationTab /> },
    ],
  },
  {
    title: "SHIPPING SAFETY",
    items: [
      { id: "shipping-overview", label: "OVERVIEW", component: <ShippingSafetyOverviewTab /> },
      // { id: "shipping-shipping", label: "SHIPPING", component: <ShippingSafetyShippingTab /> },
      // { id: "shipping-fishing", label: "FISHING", component: <ShippingSafetyFishingTab /> },
      // { id: "shipping-cleanseas", label: "CLEAN SEAS", component: <ShippingSafetyCleanseasTab /> },
      { id: "shipping-portstate", label: "PORT STATE CONTROL", component: <ShippingSafetyPortStateControlTab /> },
    ],
  },
  {
    title: "NAVAL ARCHITECTURE",
    items: [
      { id: "naval-overview", label: "OVERVIEW", component: <NavalArchitectureOverviewTab /> },
      { id: "naval-construction", label: "Vessel Construction", component: <NavalArchitectureVesselConstructionTab /> },
    ],
  },
  {
    title: "SHIP REGISTRY",
    items: [
      { id: "registry-overview", label: "OVERVIEW", component: <ShipRegistryOverviewTab /> },
      { id: "registry-registration", label: "SHIP registration", component: <ShipRegistryRegistrationTab /> },
      { id: "registry-ownership", label: "mortgages and ownership", component: <ShipRegistryMortgagesOwnershipTab /> },
      { id: "registry-offences", label: "offences", component: <ShipRegistryOffencesTab /> },
    ],
  },
  {
    title: "FISHING",
    items: [
      { id: "fishing-overview", label: "OVERVIEW", component: <FishingOverviewTab /> },
      { id: "fishing-forum", label: "NATIONAL FISHING FORUM", component: <FishingNationalFishingForumTab /> },
    ],
  },
  {
    title: "FORMS",
    items: [
      { id: "forms-all", label: "all forms", component: <FormsAllFormsTab /> },
      // { id: "forms-vessels", label: "shipping and small vessel safty forms", component: <FormsShippingSmallVesselSafetyFormsTab /> },
      // { id: "forms-seafarer", label: "SEAFARER FORMS", component: <FormsSeafarerFormsTab /> },
      // { id: "forms-registry", label: "SHIP REGISTRY FORMS", component: <FormsShipRegistryFormsTab /> },
      // { id: "forms-naval", label: "NAVAL architecture FORM", component: <FormsNavalArchitectureFormTab /> },
    ],
  },
  {
    title: "AUDIT AND ACCREDITATION",
    items: [
      { id: "audit-overview", label: "OVERVIEW", component: <AuditAccreditationOverviewTab /> },
      { id: "audit-authorized", label: "Authorised", component: <AuditAccreditationAuthorizedTab /> },
    ],
  },
  {
    title: "OFFSHORE BUNKERING",
    items: [
      { id: "OffshoreBunker-Overview", label: "OVERVIEW", component: <OffshoreBunkerOverview /> },
      { id: "Offshore-Bunkering", label: "Offshore Bunkering", component: <OffshoreBunkering /> },
      { id: "OPL-Operations", label: "OPL Operations", component: <OPLOperations /> },
    ],
  },
];

export default accordionSections;


